import { render, staticRenderFns } from "./ReviewTask.vue?vue&type=template&id=5a403972&scoped=true"
import script from "./ReviewTask.vue?vue&type=script&lang=js"
export * from "./ReviewTask.vue?vue&type=script&lang=js"
import style0 from "./ReviewTask.vue?vue&type=style&index=0&id=5a403972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a403972",
  null
  
)

export default component.exports